document.addEventListener("DOMContentLoaded", function() {

  var product__infoElems = document.querySelectorAll(".product__info-container");

  
  if(product__infoElems.length) {
    product__infoElems.forEach(function (parentForm,index) {

      var productId = parentForm.getAttribute('data-product-id');      
      var productJson = document.getElementById('ProductJson-' + productId);
      if (!productJson || !productJson.innerHTML.length) {
        return;
      }

      var productData = JSON.parse(productJson.innerHTML);
      
      var initialValue,availableOptions,selector;

      function inArray(needle, haystack) {
        if(haystack) {
          if (haystack.indexOf(needle) !== -1) {
            return true;
          } else {
            return false;
          }
        }
      }




      var Shopify = Shopify || {};
      // Required functionality from depricated options_selection.js
      Shopify.arrayIncludes = function(e, t) {
        for (var n = 0; n < e.length; n++)
          if (e[n] == t) return !0;
        return !1
      }, Shopify.uniq = function(e) {
        for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
        return t
      }
      Shopify.optionsMap = {};
      Shopify.SoldoutOptionsMap = {};
      Shopify.AllOptionsMap = {};

      Shopify.updateOptionsInSelector = function(selectorIndex) {
        
        
        switch (selectorIndex) {
          case 0:
            var key = 'root';
            selector = parentForm.querySelector('.product__info-wrapper .single-option-selector');
            break;
          case 1:
            var key = parentForm.querySelector('.product__info-wrapper .single-option-selector').value;
            selector = parentForm.querySelectorAll('.product__info-wrapper .single-option-selector')[1];
            break;
          case 2:
            var key = parentForm.querySelector('.product__info-wrapper .single-option-selector').value;  
            key += ' / ' + parentForm.querySelectorAll('.product__info-wrapper .single-option-selector')[1].value;
            selector = parentForm.querySelectorAll('.product__info-wrapper .single-option-selector')[2];
        }
        

        initialValue = selector.value;
        selector.innerHTML = '';    
        availableOptions = Shopify.optionsMap[key];
        var soldoutOptions = Shopify.SoldoutOptionsMap[key];
        var  allOption = Shopify.AllOptionsMap[key];
        
        
        var option2 = 'Select Size',
            option3 = 'Select an Option',
            option4 = 'Select Material',
            option5 = 'Select Version',
            option6 = 'Select Style';
        
        var newOption2 = document.createElement('option'),
            newOption3 = document.createElement('option'),
            newOption4 = document.createElement('option'),
            newOption5 = document.createElement('option'),
            newOption6 = document.createElement('option');
        
        newOption2.value = option2;
        newOption2.innerHTML = option2;
        newOption3.innerHTML = option3;
        newOption4.innerHTML = option4;
        newOption5.innerHTML = option5;
        newOption6.innerHTML = option6;

        if(selector.getAttribute('name') == 'options[Title]') {
          selector.appendChild (newOption3);
        } else if (selector.getAttribute('name') == 'options[Size]') {
          selector.appendChild (newOption2);
        } else if (selector.getAttribute('name') == 'options[Material]') {
          selector.appendChild (newOption4);
        } else if (selector.getAttribute('name') == 'options[Version]') {
          selector.appendChild (newOption5);
        } else if (selector.getAttribute('name') == 'options[Style]') {
          selector.appendChild (newOption6);
        }
        
        for (var i=0; i<allOption.length; i++) {
          var option = allOption[i];
          var newOption = document.createElement('option');
          newOption.value = option;
          newOption.innerHTML = option;
          

//           if(selectorIndex != 0) {
//             if (inArray(option, soldoutOptions)) {
//               newOption.setAttribute('disabled',true);
//             } else {
//               newOption.removeAttribute('disabled');
//             }
//           }

          
          selector.appendChild (newOption);
          
        }
        
        var swatchElements =  parentForm.querySelectorAll('.product-form__input[data-option-index="' + selectorIndex + '"] .swatch-element');
        if(swatchElements.length) {

          swatchElements.forEach(function(item,index) {

            var itemValue = item.getAttribute('data-value');
            var itemRadioBtn = item.querySelector('[type="radio"]');

            if (inArray(itemValue, allOption)) {
              item.classList.remove('soldout'); 
              item.style.display = 'flex';
              if(itemRadioBtn) {
                itemRadioBtn.removeAttribute('disabled');
                itemRadioBtn.checked = false;
              }
            } else {

              if (inArray(itemValue, soldoutOptions)) {

                item.classList.remove('soldout');
                item.style.display = 'flex';
                if(itemRadioBtn) {
                  itemRadioBtn.removeAttribute('disabled');
                  itemRadioBtn.checked = false;
                }
              } else {
                item.classList.add('soldout');
                item.style.display = 'none';
                if(itemRadioBtn) {
                  itemRadioBtn.getAttribute('disabled','disabled');
                  itemRadioBtn.checked = false;
                }
              }
            
            }
          });
        }
        
        if (inArray(initialValue, availableOptions)) {
          if(selector) {
            selector.value = initialValue;

            var activeSwatch = parentForm.querySelector('.product-form__input[data-option-index="' + selectorIndex + '"] .swatch-element[data-value="'+ initialValue + '"] [type="radio"]');
            if(activeSwatch) {
              // activeSwatch.checked = true;
              activeSwatch.checked = false;
            }
          }
          } else {
            if(selector) {


              if (inArray(initialValue, soldoutOptions)) {
                if(selector) {
                  selector.value = initialValue;

                  var activeSwatch = parentForm.querySelector('.product-form__input[data-option-index="' + selectorIndex + '"] .swatch-element[data-value="'+ initialValue + '"] [type="radio"]');
                  if(activeSwatch) {
                    // activeSwatch.checked = true;
                    activeSwatch.checked = false;
                  }
                }
              } else {
                
                if(availableOptions) {
                  selector.value = availableOptions[0];

                  selector.dispatchEvent(new Event('change', { bubbles: true }));

                  var activeSwatch = parentForm.querySelector('.product-form__input[data-option-index="' + selectorIndex + '"] .swatch-element[data-value="'+ availableOptions[0] + '"] [type="radio"]');
                  if(activeSwatch) {
                    // activeSwatch.checked = true;
                    activeSwatch.checked = false;
                  }
                }
              }

          }
        }

      }

      Shopify.linkOptionSelectors = function(product) {
        
        if(product) {
          // Building our mapping object.
          for (var i=0; i<product.variants.length; i++) {
            var variant = product.variants[i];
            
               
          // Gathering values for the 1st drop-down.
          Shopify.AllOptionsMap['root'] = Shopify.AllOptionsMap['root'] || [];
          Shopify.AllOptionsMap['root'].push(variant.option1);
          Shopify.AllOptionsMap['root'] = Shopify.uniq(Shopify.AllOptionsMap['root']);
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            Shopify.AllOptionsMap[key] = Shopify.AllOptionsMap[key] || [];
            Shopify.AllOptionsMap[key].push(variant.option2);
            Shopify.AllOptionsMap[key] = Shopify.uniq(Shopify.AllOptionsMap[key]);
          }
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + ' / ' + variant.option2;
            Shopify.AllOptionsMap[key] = Shopify.AllOptionsMap[key] || [];
            Shopify.AllOptionsMap[key].push(variant.option3);
            Shopify.AllOptionsMap[key] = Shopify.uniq(Shopify.AllOptionsMap[key]);
          }

            
            
            if (variant.available) {
              // Gathering values for the 1st drop-down.
              Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
              Shopify.optionsMap['root'].push(variant.option1);
              Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
              // Gathering values for the 2nd drop-down.
              if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
              }
              // Gathering values for the 3rd drop-down.
              if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
              }
            } else {
          
            // Gathering values for the 1st drop-down.
            Shopify.SoldoutOptionsMap['root'] = Shopify.SoldoutOptionsMap['root'] || [];
            Shopify.SoldoutOptionsMap['root'].push(variant.option1);
            Shopify.SoldoutOptionsMap['root'] = Shopify.uniq(Shopify.SoldoutOptionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
              var key = variant.option1;
              Shopify.SoldoutOptionsMap[key] = Shopify.SoldoutOptionsMap[key] || [];
              Shopify.SoldoutOptionsMap[key].push(variant.option2);
              Shopify.SoldoutOptionsMap[key] = Shopify.uniq(Shopify.SoldoutOptionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
              var key = variant.option1 + ' / ' + variant.option2;
              Shopify.SoldoutOptionsMap[key] = Shopify.SoldoutOptionsMap[key] || [];
              Shopify.SoldoutOptionsMap[key].push(variant.option3);
              Shopify.SoldoutOptionsMap[key] = Shopify.uniq(Shopify.SoldoutOptionsMap[key]);
            }    	
          }
          }
                   

          // Update options right away.


          Shopify.updateOptionsInSelector(0);
          if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
          if (product.options.length === 3) Shopify.updateOptionsInSelector(2);


          // When there is an update in the first dropdown.
          var firstSelectEl = parentForm.querySelectorAll('.single-option-selector')[0];
          
          firstSelectEl.getElementsByTagName('option')[0].selected = 'selected';
          
          if(firstSelectEl) {
            firstSelectEl.addEventListener('change', function() {

              
              
              Shopify.updateOptionsInSelector(1);
              if (product.options.length === 3)  {
                Shopify.updateOptionsInSelector(2);
              }
              return true;
            });
          }       

          // When there is an update in the second dropdown.
          var secondSelectEl = parentForm.querySelectorAll('.single-option-selector')[1];
          if(secondSelectEl) {
            secondSelectEl.addEventListener('change', function () {                                
              if (product.options.length === 3) {
                Shopify.updateOptionsInSelector(2);
              }

              return true;
            });
          }

        }
      };
      
      
      if( productData.options.length >= 1 &&  productData.variants.length >= 1) {
     
        if (window.MutationObserver && parentForm) {
          if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
            observer.disconnect();
          }
          var config = { childList: true, subtree: true };
          var observer = new MutationObserver(function() {   
            Shopify.linkOptionSelectors(productData);
            observer.disconnect();
          });  
          observer.observe(parentForm, config);
        }
      } 


      var selector = parentForm.querySelector('.single-option-selector');
      if(selector) {
        selector.dispatchEvent(new Event('change', { bubbles: true }));
      }


      if(productData.options.length == 1) {
        for(var v=0;v < productData.variants.length;v++) {
          var variant = productData.variants[v];

          if(!variant.available) {

            var allSelectOptionsEl = parentForm.querySelectorAll('.single-option-selector option');
            if(allSelectOptionsEl.length) {
              allSelectOptionsEl.forEach(function(item,index) {
                var itemText = item.innerHTML.trim();
                if(itemText == variant.title) {
                   var swatchEl =  parentForm.querySelector(".product_swatch [data-value='"+variant.title+"']");
                  
                  item.classList.remove('soldout');
                  item.style.display = 'flex';
                  if(swatchEl) {
                    swatchEl.removeAttribute('disabled');
                    swatchEl.checked = false;
                  }

//                   item.parentNode.removeChild(item);
                 

//                   if(swatchEl) {
//                     swatchEl.parentNode.removeChild(swatchEl);
//                   }
                }
              });
            }


          }
        }

        var selectors = parentForm.querySelectorAll('.single-option-selector');
        if(selectors.length) {
          selectors.forEach(function (select,index) {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }      

      }


    });
  }



});